export const KEY = {
  CLIENT_WEB: process.env.REACT_APP_CLIENT_WEB,
  CLIENT_TOKEN: process.env.REACT_APP_CLIENT_TOKEN,
};
